import { Directive, HostListener, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

@Directive({
    selector: '[appPhoneNumberSanitizer]',
    standalone: true,
})
export class PhoneNumberSanitizerDirective {
  @Input() formControl: UntypedFormControl;

  @HostListener('input', ['$event.target.value'])
  handleInput(value: string) {
    if (value.startsWith('*')) {
      return;
    }

    const phoneNumber = parsePhoneNumberFromString(value, { defaultCountry: 'US', extract: true });

    if (phoneNumber?.isValid()) {
      const nationalNumber = phoneNumber.nationalNumber;

      this.formControl?.setValue(nationalNumber);
    }
  }
}
